// ────────────────────────────────────────────────────────────────────────────
// GlitchTip / Sentry — frontend SDK init (musi być na samej górze!)
// ────────────────────────────────────────────────────────────────────────────
import * as Sentry from '@sentry/browser';

if (import.meta.env.VITE_SENTRY_DSN) {
    const releaseMeta = document.querySelector('meta[name="app-version"]');
    const appRelease = releaseMeta ? releaseMeta.getAttribute('content') : undefined;

    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
        release: appRelease,
        autoSessionTracking: false, // GlitchTip nie wspiera sesji
        tracesSampleRate: 0,        // performance off (GlitchTip ograniczone)
        sendDefaultPii: false,
        denyUrls: [
            /extensions\//i,
            /^chrome:\/\//i,
            /^moz-extension:\/\//i,
            /^safari-extension:\/\//i,
        ],
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
            'NetworkError when attempting to fetch resource',
            'AbortError',
            // jQuery/AJAX szum z auto CSRF refresh
            /Request failed with status code 419/,
            /CSRF token mismatch/,
            /^Script error\.?$/,
        ],
        integrations: [
            Sentry.breadcrumbsIntegration({ console: false }),
        ],
    });

    const userMeta = document.querySelector('meta[name="sentry-user"]');
    if (userMeta) {
        try {
            Sentry.setUser(JSON.parse(userMeta.getAttribute('content')));
        } catch (e) { /* malformed meta — ignore */ }
    }

    window.Sentry = Sentry;
}

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

/**
 * Choices.js - autocomplete library for better UX in select fields
 */
import Choices from 'choices.js';
window.Choices = Choices;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
    forceTLS: true
});